var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgWallet = function SvgWallet(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6071 11.4263V8.5692C17.6071 8.19032 17.4566 7.82695 17.1887 7.55904C16.9208 7.29114 16.5574 7.14062 16.1786 7.14062H2.60713C2.22825 7.14062 1.86489 7.29114 1.59698 7.55904C1.32907 7.82695 1.17856 8.19032 1.17856 8.5692V18.5692C1.17856 18.9481 1.32907 19.3114 1.59698 19.5793C1.86489 19.8473 2.22825 19.9978 2.60713 19.9978H16.1786C16.5574 19.9978 16.9208 19.8473 17.1887 19.5793C17.4566 19.3114 17.6071 18.9481 17.6071 18.5692V14.9978",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94998 3.56923L14.05 1.45494C14.141 1.4293 14.2363 1.42236 14.33 1.43455C14.4238 1.44674 14.5142 1.4778 14.5956 1.52587C14.677 1.57393 14.7479 1.63799 14.8039 1.71419C14.8599 1.7904 14.8999 1.87715 14.9214 1.96923L15.3214 3.56923",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0357 11.4263H15.4643C15.0698 11.4263 14.75 11.7461 14.75 12.1406V14.2834C14.75 14.6779 15.0698 14.9977 15.4643 14.9977H19.0357C19.4302 14.9977 19.75 14.6779 19.75 14.2834V12.1406C19.75 11.7461 19.4302 11.4263 19.0357 11.4263Z",
    stroke: "#000001",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet.52109d688db8eb3abc6910aa81e68f5e.svg";